/**
 * Maintenance / “under construction” gate.
 *
 * 1) Build-time: set REACT_APP_MAINTENANCE_MODE=true before `npm run build`.
 * 2) Runtime (no rebuild): place `maintenance-config.json` in the deployed site root
 *    (same folder as index.html — typically copied from `public/`). When the file sets
 *    "useRuntime": true, the boolean "enabled" overrides the env flag until you edit
 *    the file again. With "useRuntime": false (default in repo), only the env flag applies.
 */
export async function resolveMaintenanceMode() {
  const fromEnv = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const url = `${prefix}/maintenance-config.json`;

  try {
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return fromEnv;
    const data = await res.json();
    if (data && data.useRuntime === true && typeof data.enabled === 'boolean') {
      return data.enabled;
    }
  } catch {
    // Missing file, invalid JSON, or offline — fall back to env
  }
  return fromEnv;
}
